import { create } from 'zustand';
import { KEYBED_ROOT_NOTE } from '../core/constants';

const OCTAVE_MIN = -3;
const OCTAVE_MAX = 3;

interface KeyboardStore {
  /** MIDI note numbers currently sounding. */
  held: number[];
  /** Octaves the computer keyboard is shifted by. */
  octave: number;
  hold: (note: number) => void;
  release: (note: number) => void;
  clear: () => void;
  shiftOctave: (step: number) => void;
}

export const useKeyboardStore = create<KeyboardStore>((set, get) => ({
  held: [],
  octave: 0,
  hold: (note) => {
    if (!get().held.includes(note)) set({ held: [...get().held, note] });
  },
  release: (note) => {
    if (get().held.includes(note)) set({ held: get().held.filter((n) => n !== note) });
  },
  clear: () => set({ held: [] }),
  shiftOctave: (step) =>
    set({ octave: Math.max(OCTAVE_MIN, Math.min(OCTAVE_MAX, get().octave + step)) }),
}));

/** `Key_3` -> MIDI note 55. */
export function meshNameToNote(name: string): number | null {
  const match = /^Key_(\d+)$/.exec(name);
  return match ? KEYBED_ROOT_NOTE + Number(match[1]) : null;
}
